export const ADMISSIONS_ROUTES = {
  admission     : 'formulario/hospitalización',
  historyPatient: 'historial/ordenes/hospitalizaciones/paciente',
};
